import React from 'react';
import Layout from '../Layout';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';

const TestLogin = ({ onRecoveryBtn, onLogin }) => {
  return (
    <Layout withoutNavOptions>
      <div className="Login">
        <h2 className="efpa-h2 efpa-text toUppercase Login-title">
          Exámenes efpa - acceso
        </h2>
        <div className="Login-content">
          <LoginForm onRecoveryBtn={onRecoveryBtn} onLogin={onLogin} />
          <RegisterForm />
        </div>
      </div>
    </Layout>
  );
};

export default TestLogin;
